<template>
  <base-progress
    v-slot="{ percentage }"
    v-bind="$props"
    class="overflow-hidden"
    :class="brandClasses.container"
    data-test-id="vf-progress-bar"
    role="presentation"
  >
    <div
      class="h-full"
      :class="[brandClasses.progress, classProgress]"
      :style="`width: ${percentage}%`"
    />
  </base-progress>
</template>

<script lang="ts" setup>
import type { CSSClass } from '#types/common'

defineProps<{
  /**
   * Defines maximum (total) value that can be achieved
   */
  max?: number | string
  /**
   * Defines current value
   */
  value?: number | string
  /**
   * Classes to be applied to the progress
   */
  classProgress?: CSSClass
}>()

const { brandClasses } = useAppConfig().components.vf.progressBar
</script>
